import { Component, OnInit } from "@angular/core";
import { DialogService, DynamicDialogConfig, DynamicDialogRef } from "primeng/dynamicdialog";
import { ServiceTermsComponent } from "src/app/components/service-terms/service-terms.component";
@Component({
    selector: "app-modal-send-approve",
    templateUrl: "./modal-send-approve.component.html",
    styleUrls: ["./modal-send-approve.component.scss"],
})
export class ModalSendApproveComponent implements OnInit {
    constructor(
        private dialogService: DialogService,
        private ref: DynamicDialogRef,
        private config: DynamicDialogConfig,
    ) {}

    ngOnInit(): void {}

    async approveVehicle() {
      this.config.data.approve();
      this.ref.close();
    }

    closeModal() {
      this.ref.close();
    }

    showPrivacyPolicy() {
        this.dialogService.open(ServiceTermsComponent, {
            header: "Termos de Uso",
            height: "100%",
            width: window.innerHeight < 600 ? "98%" : "60%",
            data: {
                title: "Nossos termos de uso",
                isAcceptedTerm: false
            }
        });
    }
}
